import { render, staticRenderFns } from "./SaldosEntradas.vue?vue&type=template&id=c834c2a0&scoped=true"
import script from "./SaldosEntradas.vue?vue&type=script&lang=ts"
export * from "./SaldosEntradas.vue?vue&type=script&lang=ts"
import style0 from "./SaldosEntradas.vue?vue&type=style&index=0&id=c834c2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c834c2a0",
  null
  
)

export default component.exports